// RAW — Brand JS

(function() {

  var body = document.body;

  // ── 1. Scroll progress bar ──────────────────────────────────────────────
  var scrollBar = document.getElementById('scroll-bar');
  if (scrollBar) {
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) scrollBar.style.width = (scrolled / total * 100) + '%';
    }, { passive: true });
  }


  // ── 2. Custom cursor ────────────────────────────────────────────────────
  var cursor = document.getElementById('raw-cursor');
  if (cursor) {
    var cursorX = 0, cursorY = 0;
    document.addEventListener('mousemove', function(e) {
      cursorX = e.clientX;
      cursorY = e.clientY;
      cursor.style.left = cursorX + 'px';
      cursor.style.top  = cursorY + 'px';
    });
    document.addEventListener('mouseenter', function() { cursor.style.opacity = '1'; });
    document.addEventListener('mouseleave', function() { cursor.style.opacity = '0'; });

    var hoverTargets = 'a, button, [onclick], label, .product-card, input, select, textarea';
    document.addEventListener('mouseover', function(e) {
      if (e.target.closest(hoverTargets)) body.classList.add('cursor-hover');
    });
    document.addEventListener('mouseout', function(e) {
      if (!e.target.closest(hoverTargets)) body.classList.remove('cursor-hover');
    });
  }


  // ── 3. Page transition ──────────────────────────────────────────────────
  var overlay = document.getElementById('page-transition');
  if (overlay && body.classList.contains('fx-transition')) {
    // Fade out on load
    overlay.classList.remove('is-entering');

    // Fade in on navigation
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto') ||
          href.startsWith('tel') || link.target === '_blank' ||
          link.hasAttribute('download')) return;
      // Only internal links
      if (href.startsWith('/') || href.includes(window.location.host)) {
        e.preventDefault();
        overlay.classList.add('is-entering');
        setTimeout(function() {
          window.location = link.href;
        }, 120);
      }
    });

    // Fade out when back/forward
    window.addEventListener('pageshow', function() {
      overlay.classList.remove('is-entering');
    });
  }


(function() {

  // ── Hero full-screen on mobile ──────────────────────────────────────────
  // CSS dvh/svh units are unreliable on iOS Safari.
  // window.innerHeight gives the true visual viewport height.
  function setHeroHeight() {
    if (window.innerWidth > 768) return;

    var hero   = document.querySelector('.hero');
    var figure = document.querySelector('.hero__figure');
    var media  = document.querySelector('.hero__media');
    if (!hero) return;

    var h = window.innerHeight + 'px';

    hero.style.height        = h;
    hero.style.minHeight     = h;
    hero.style.paddingTop    = '0';
    hero.style.paddingBottom = '0';

    if (figure) {
      figure.style.height   = h;
      figure.style.maxWidth = '100%';
    }
    if (media) {
      media.style.height = h;
    }
  }

  // Run immediately and on orientation change
  setHeroHeight();
  window.addEventListener('orientationchange', function () {
    setTimeout(setHeroHeight, 300);
  });
  window.addEventListener('resize', setHeroHeight);


  // ── Gallery slideshow ───────────────────────────────────────────────────
  window.galleryGoTo = function(id, n) {
    var el = document.getElementById('gallery-' + id);
    if (!el) return;
    var slides = el.querySelectorAll('.gallery-slide');
    var dots   = document.querySelectorAll('#gallery-dots-' + id + ' .gallery-dot');
    slides.forEach(function(s, i) { s.classList.toggle('is-active', i === n); });
    dots.forEach(function(d, i)   { d.classList.toggle('is-active', i === n); });
    el.dataset.current = n;
  };

  window.galleryPrev = function(id) {
    var el = document.getElementById('gallery-' + id);
    if (!el) return;
    var total = el.querySelectorAll('.gallery-slide').length;
    var cur   = parseInt(el.dataset.current || 0);
    galleryGoTo(id, (cur - 1 + total) % total);
  };

  window.galleryNext = function(id) {
    var el = document.getElementById('gallery-' + id);
    if (!el) return;
    var total = el.querySelectorAll('.gallery-slide').length;
    var cur   = parseInt(el.dataset.current || 0);
    galleryGoTo(id, (cur + 1) % total);
  };


  // ── Cart quantity update ────────────────────────────────────────────────
  window.updateQty = function(line, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function() { location.reload(); });
  };

})();

})(); // close outer IIFE
